import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const chatNotification = createAsyncThunk('chatNotification', async (data) => {

    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `chat_alert`,
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const chatNotificationSlice = createSlice({
    name: 'chatNotification',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(chatNotification.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                state.data = [];
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            } else {
                state.data = [];
            }
        });
        builder.addCase(chatNotification.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default chatNotificationSlice.reducer; 